import { useState, useEffect, useRef } from 'react'
import { createUrl } from '@common/util'
import ajax from '@common/ajax'
import SurveyExcerpt from './SurveyExcerpt'
import HideColumnButton from './HideColumnButton'
import Spinner from '@react/common/components/Spinner'
import InlineSpinner from '@react/common/components/InlineSpinner'
import useIntersectionObserver from '@react/common/hooks/useIntersectionObserver'

function Surveys({ data, isVisible, supportsTwoColumns, hideColumn, canHide }) {
  const [items, setItems] = useState(data.items)
  const [heading, setHeading] = useState(data.heading)
  const [hasMore, setHasMore] = useState(data.hasMore)
  const [hasScrollbar, setHasScrollbar] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const scrollerRef = useRef(null)
  const loaderRef = useRef(null)
  const entry = useIntersectionObserver(loaderRef, {})
  const isLoaderVisible = !!entry?.isIntersecting

  const fetchItems = async (isLoadingMore = false) => {
    setIsLoading(true)

    const start = isLoadingMore ? items.length + 1 : 0
    const url = createUrl(window.location, { fetch: 'surveys', start }, true)
    const res = await ajax.get(url).json()

    if (start === 0) {
      setItems(res.items)
    } else {
      setItems((current) => [...current, ...res.items])
    }

    setHasMore(res.hasMore)
    setHeading(res.heading)
    setIsLoading(false)
  }

  useEffect(() => {
    if (isLoaderVisible && !isLoading) {
      fetchItems(true)
    }
  }, [isLoaderVisible, isLoading])

  useEffect(() => {
    if (scrollerRef && scrollerRef.current) {
      const el = scrollerRef.current

      setHasScrollbar(el.scrollHeight >= el.offsetHeight)
    }
  }, [scrollerRef])

  let containerClasses = 'grid gap-8 lg:gap-16'
  const asTwoColumns = !supportsTwoColumns || !canHide

  if (asTwoColumns) {
    containerClasses = 'grid md:grid-cols-2 gap-8 lg:gap-16'
  }

  return (
    <div className={`h-[60vh] ${isVisible ? 'block' : 'hidden'}`}>
      {isLoading && <Spinner />}

      <div className="flex justify-between items-center mb-8">
        <h2 className="text-primary h4">{heading}</h2>
        {supportsTwoColumns && canHide && (
          <div className="ml-4">
            <HideColumnButton column="surveys" hideColumn={hideColumn} />
          </div>
        )}
      </div>

      <div className={`ai-scroller-container h-full ${hasScrollbar && 'has-scrollbar'}`}>
        <div className="overflow-y-auto overflow-x-hidden h-full ai-scroller overflow-scroll-touch" ref={scrollerRef}>
          <div className={`${containerClasses}`}>
            {items.map((item) => (
              <SurveyExcerpt key={item.id} {...item} />
            ))}
          </div>

          {hasMore && (
            <div className={`py-16 ${isLoading ? 'hidden' : ''}`} ref={loaderRef}>
              <InlineSpinner />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Surveys
